import { CircularProgress, FormControl, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";
import {
  errorToaster,
  successToaster,
} from "../../../../helper/toasterConfiguration";
import StatusChangeModal from "./status-change-modal";
import { useDispatch } from "react-redux";
import { setOpen } from "../../../../Redux/ModalReducer";

const StatusChanger = ({ data, setData, rowsPerPage, currentPage, status }) => {
  const dispatch = useDispatch();
  const [isChangeStatusLoading, setIsChangeStatusLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [newStatus, setNewStatus] = useState();

  const handleOpen = () => {
    setShow(true);
    dispatch(setOpen(true));
  };

  const handleClose = () => {
    setShow(false);
    dispatch(setOpen(false));
  };

  const handleRowStatusChange = async (id, newStatus) => {
    setIsChangeStatusLoading(true);
    const { response, message } = await Helper.Put({
      url: `${api_Routes.BannersAdvertising.UpdateStatus}${id}`,
      data: { status: newStatus },
      hasToken: true,
    });
    if (response) {
      const { response: updatedData } = await Helper.Get({
        url: `${
          api_Routes.BannersAdvertising.View
        }?per_page=${rowsPerPage}&page=${currentPage + 1}${
          status && status !== "null" ? `&status=${status}` : ""
        }`,
        hasToken: true,
      });

      if (updatedData) {
        setData(updatedData);
      }
      successToaster(message || "The status update was successful");
    } else {
      errorToaster(message || "Failed to update the status");
    }
    handleClose();
    setIsChangeStatusLoading(false);
  };

  return (
    <>
      <FormControl size="small" className="w-40">
        <Select
          value={data?.status}
          onChange={(e) => {
            handleOpen();
            setNewStatus(e.target.value);
          }}
          sx={{
            "& .MuiSelect-select": {
              backgroundColor:
                data?.status === "active"
                  ? "#28a745"
                  : data?.status === "pending"
                  ? "#f7cb73"
                  : "#114787",
              color: "white",
            },
          }}
        >
          <MenuItem value="active">
            {isChangeStatusLoading ? (
              <CircularProgress size={18} sx={{ color: "white" }} />
            ) : (
              "Active"
            )}
          </MenuItem>
          <MenuItem value="pending">
            {isChangeStatusLoading ? (
              <CircularProgress size={18} sx={{ color: "white" }} />
            ) : (
              "Pending"
            )}
          </MenuItem>
          <MenuItem value="complete">
            {isChangeStatusLoading ? (
              <CircularProgress size={18} sx={{ color: "white" }} />
            ) : (
              "Complete"
            )}
          </MenuItem>
        </Select>
      </FormControl>
      <StatusChangeModal
        show={show}
        handleClose={handleClose}
        handleSubmit={handleRowStatusChange}
        isLoading={isChangeStatusLoading}
        data={data}
        newStatus={newStatus}
      />
    </>
  );
};

export default StatusChanger;
